<template>
    <div>
        <div class="header_wrap" ref="header">
            <div class="topBar-home">
                <div class="">
                    <div @click="navigateToDashboard">
                        <img src="./assets/images/header/logo.png" height="35px"/>
                        <img src="./assets//images//header/logo_text.png" width="300px">
                    </div>
                </div>
         
                <div class="d-flex">
                   
              
                    <div class="mt-2">
                        <b-dropdown id="dropdown-lang" left variant="link" toggle-class="my-dropdown"
                            @show="toggleDropdown" @hide="toggleDropdown">
                            <template #button-content>
                                <span class="text-white text-16 font-weight-bold text-uppercase">
                                    <span v-if="$i18n.locale == 'zh'">CN</span>
                                    <span v-else-if="$i18n.locale == 'my'">MY</span>
                                    <span v-else>{{ 'en' }}</span>
                                </span>
                            </template>
                            <b-dropdown-item href="#" @click="$root.changeLan('en')">English</b-dropdown-item>
                            <b-dropdown-item href="#" @click="$root.changeLan('zh')">中文</b-dropdown-item>
                            <b-dropdown-item href="#" @click="$root.changeLan('my')">Malay</b-dropdown-item>
                        </b-dropdown>
                    </div>
                </div>
            </div>
        </div>
        <b-sidebar id="sidebar-right" title="Sidebar" no-header right shadow backdrop>
            <div class="">
                <div class="topBar-sidebar py-4">
                    <div class="d-flex ml-4 mb-3">
                        <img src="./assets/images/profile/user.png" width="40px" height="40px" class="mt-2">
                        <div class="profile-banner mt-3 text-12">
                            <span class="text-14 font-weight-bold">{{ $root.userInfo.username }}</span>
                            <!-- <div v-if="$root.userInfo.premium_member == 1" class="profile-rankbox">Premium User</div>
                            <div v-else  class="profile-rankbox">Normal User</div> -->
                        </div>

                    </div>
                </div>
                <div class="myorder-bg">
                    <div class="text-secondary text-left font-weight-bold text-16 ml-4">{{ $t('my_orders') }}</div>
                    <div class="myorder-box ml-4">
                        <div v-for="item in myOrder" :key="item.name" class="myorder-item mt-2"
                            @click="$router.push(item.path)">
                            <img :src="require(`./assets/images/profile/${item.name}.png`)" alt="my-order"
                                class="myorder-icon">
                            <div class="myorder-text font-weight-bold">{{ $t(item.name) }}</div>
                        </div>
                    </div>
                </div>
                <div class="text-left">

                    <div class="text-secondary font-weight-bold text-18 mb-3">{{ $t('general') }}</div>
                    <!-- <div v-for="item in bonus_record" :key="item" class="card-me mb-2"
                        @click="$router.push('/web/' + item)"> -->
                    <div v-for="item in bonus_record" :key="item" class="card-me mb-2">
                        <div class="d-flex justify-content-between">
                            <span>
                                <img :src="require('./assets/images/profile/' + item + '.png')" alt="" height="auto"
                                    width="auto">
                                <span class=" text-14 font-weight-600 ml-2">{{ $t(item) }}</span>
                            </span>
                            <span><i class="fa fa-chevron-right mt-2"></i></span>
                        </div>
                    </div>
                    <div class="card-me text-center text-danger mt-3" @click="logout()">{{ $t('logout') }}</div>

                </div>
            </div>
        </b-sidebar>
    </div>
</template>
<script>
import { getProduct } from '@/system/request/api/api';
export default {
    computed: {
          
    },
    data() {
        return {
            searchCategory: '',
            productsLists: [],
            show: false,
            isDropdownOpen: false,
            companies: [
            ],
            myOrder: [
                // {name:'payment'},
                // {name:'process'},
                // {name:'confirmation'},
                { name: 'orderHistory', path: '/web/product/orderHistory' },
                { name: 'hotel_booking', path: '/web/hotel/orderHotelHistory' },
            ],
            bonus_record: [
                // "edit_profile",
                // "withdraw_details",
                // "language",
                // "announcement",
                // "security_center",
                "contact_us",

            ]
        };
    },
    methods: {
        clearSearch() {
            this.searchCategory = '';
            this.productsLists = [];
        },
        navigateToProduct(id) {
            this.$router.push('/web/product/details?id=' + id);
            this.clearSearch();

            // Force reactivity update
            this.$nextTick(() => {
                this.productsLists = [];
            });
        },
        getProduct() {
            this.$root.isLoading = true;
            var result = getProduct(
                '',
                this.searchCategory,
                1
            );
            var self = this;
            result
                .then(function (value) {
                    self.$root.isLoading = false;
                    self.lastPage = value.data.data.mall_product.last_page;
                    self.productsLists = value.data.data.mall_product.data.map(product => {
                        let parsedPrice = JSON.parse(product.price);
                        return {
                            ...product,
                            price: parsedPrice,
                            normalCredit: parsedPrice.normal_credit,
                            premiumCredit: parsedPrice.premium_credit,
                            normalCash: parsedPrice.normal_cash,
                            premiumCash: parsedPrice.premium_cash
                        };
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
    
        toggleDropdown() {
            this.isDropdownOpen = !this.isDropdownOpen;
        },
        logout() {
            localStorage.removeItem('currencyToken');
            localStorage.removeItem('info');
            var baseUrl = `https://${window.location.hostname.replace('mall.', window.location.href.includes('uat') ? '.' : '')}`
            window.location.href = baseUrl;
        },
        navigateToDashboard() {
            if (this.$route.path === "/web/homepage") {
                this.$router.go(0); 
            } else {
                this.$router.push("/web/homepage");
            }
        }
    },
}
</script>

<style>
.login {
    background-image: url('./assets/images/bg/bg3.png') !important;
}
</style>
